import { URLS } from 'api/constants';
import {
  ICasinoCollection,
  ISlotCollection,
  IStreamerCollection,
} from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationResponse } from './types';

export async function listCasinoCollections() {
  const data = await apiGet<PaginationResponse<ICasinoCollection>>(
    URLS.CASINOS_COLLECTIONS
  );
  return data.results ?? [];
}

export async function getCasinoCollectionByName(name?: string) {
  return apiGetSafe<ICasinoCollection>(
    `${URLS.CASINOS_COLLECTION_BY_NAME}${name ?? ''}`
  );
}

export async function getCasinoCollectionById(id?: string) {
  return apiGetSafe<ICasinoCollection>(
    `${URLS.CASINOS_COLLECTION_BY_ID}${id ?? ''}`
  );
}

export async function listSlotCollections() {
  const data = await apiGet<PaginationResponse<ISlotCollection>>(
    URLS.SLOT_COLLECTIONS
  );
  return data.results ?? [];
}

export async function getSlotCollectionByName(name?: string) {
  return apiGetSafe<ISlotCollection>(
    `${URLS.SLOT_COLLECTION_BY_NAME}/${name ?? ''}`
  );
}

export async function getSlotCollectionById(id?: string) {
  return apiGetSafe<ISlotCollection>(
    `${URLS.SLOT_COLLECTION_BY_ID}${id ?? ''}`
  );
}

export async function listStreamerCollections(params?: {
  streamers_limit?: number;
}) {
  const data = await apiGet<PaginationResponse<IStreamerCollection>>(
    URLS.STREAMER_COLLECTIONS,
    params
  );
  return data.results ?? [];
}

export async function getStreamerCollectionByName(name?: string) {
  return apiGetSafe<IStreamerCollection>(
    `${URLS.STREAMER_COLLECTION_BY_NAME}${name ?? ''}`
  );
}
